module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis-7303660-2.2c911c02.jpg";